// extracted by mini-css-extract-plugin
export var avatarContainer = "_4j-1";
export var largeAvatarContainer = "_4j-2";
export var smallAvatarContainer = "_4j-0";